export default __webpack_public_path__ + "static/media/DualGold.73f4c59f.png";